import { render, staticRenderFns } from "./teachAdmin.vue?vue&type=template&id=2456c99a&"
import script from "./teachAdmin.vue?vue&type=script&lang=js&"
export * from "./teachAdmin.vue?vue&type=script&lang=js&"
import style0 from "./teachAdmin.vue?vue&type=style&index=0&id=2456c99a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports